import type { State } from '../../store/types.js';
import {
  employeeGroupsAsListItems,
  employeesAsListItems,
  employeesNotDeleted,
  functionsNotDeleted,
  key,
} from '../../store/selectors';
import type { AbstractPageView } from 'src/pages/abstract-page-view';
import type { EmployeesPageViewModel } from '../../pages/employees-page/employees-page-view-model';
import { BASE_PATH } from '../../store';
import { getFeatureStates } from '../../store/selectors/features/getFeatureStates';

export function employeesPageView(
  hrefPrefix: string,
  viewModel: AbstractPageView,
  state: State,
): EmployeesPageViewModel {
  const o = state.organization;
  if (o === undefined) {
    throw new Error('Illegal state (E151), organization not found');
  }
  const featureStates = getFeatureStates(state);
  let employees = employeesAsListItems(hrefPrefix, employeesNotDeleted(state));
  if (featureStates.entityEmployeesComplete || featureStates.performanceReview) {
    employees = employeeGroupsAsListItems(
      hrefPrefix,
      employeesNotDeleted(state),
      functionsNotDeleted(state),
      featureStates,
    );
  }
  return {
    ...viewModel,
    type: 'employees-page',
    icon: 'employees',
    href: hrefPrefix,
    pdfHref: BASE_PATH + '/organizations/' + o.organizationId + '/overview.pdf?key=' + key(state),
    employees,
  };
}
